import type { StatsData } from "@/types/dashboard";

export type { StatsData };

interface DashboardStatsProps {
  stats: StatsData;
}

export function DashboardStats({ stats }: DashboardStatsProps) {
  return (
    <div className="flex flex-wrap gap-[30px]">
      <StatCard title="Total Domains" value={stats.total} />
      <StatCard title="Live Sites" value={stats.live} />
      <StatCard title="Jetsik Live" value={stats.jetsikLive} />
      <StatCard title="Other Type Live" value={stats.otherLive} />
      <StatCard title="New" value={stats.newDomains} />
      <StatCard title="Bought" value={stats.bought} />
    </div>
  );
}

function StatCard({ title, value }: { title: string; value: number | string }) {
  return (
    <div className="flex flex-1 flex-col justify-center rounded-2xl border border-border bg-card px-5 py-4">
      <span className="mb-2.5 whitespace-nowrap text-sm font-medium text-muted-foreground">
        {title}
      </span>
      <span className="text-2xl font-semibold tabular-nums tracking-tight text-foreground">
        {value}
      </span>
    </div>
  );
}
